import React from 'react';
import PropTypes from 'prop-types';
import { Loader, Text } from '@playbookux/playbook-web-core';
import {
  Button,
  Modal as ModalSemantic,
  ModalActionContainer,
} from '../styles';

const ConfirmationModal = ({
  showModal,
  handleActionModal,
  handleCloseModal,
  message,
  loading,
}) => (
  <ModalSemantic
    open={showModal}
    closeOnEscape
    closeOnDimmerClick
    onClose={handleCloseModal}
  >
    <Text>{message}</Text>

    <ModalActionContainer>
      <Button
        type="button"
        onClick={handleCloseModal}
        backgroundColor="#FFFFFF"
        color="#4D5473"
        disabled={loading}
      >
        No
      </Button>

      <Button
        type="button"
        onClick={handleActionModal}
        disabled={loading}
      >
        {loading
          ? <Loader size="tiny" data-loader="confirmation-loader" />
          : 'Yes'}
      </Button>
    </ModalActionContainer>
  </ModalSemantic>
);

ConfirmationModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  handleActionModal: PropTypes.func.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired,
};

export default ConfirmationModal;
